module.exports = __webpack_public_path__ + "img/jf_home_03.aa1dd22e.jpg";